import { ItemChartModel } from '../global/item-chart.model';

export class ServiceChartModel {
  total: number = 0;
  states: ItemChartModel[] = [];
}
